import { render, staticRenderFns } from "./TipoPagamento.vue?vue&type=template&id=6f028422&scoped=true&"
import script from "./TipoPagamento.vue?vue&type=script&lang=js&"
export * from "./TipoPagamento.vue?vue&type=script&lang=js&"
import style0 from "./TipoPagamento.vue?vue&type=style&index=0&id=6f028422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f028422",
  null
  
)

export default component.exports